import { USER_ROLE } from "libs/constant/role";
import useAuth from "libs/hooks/useAuth";
import _ from "lodash";
import React from "react";
import {
  matchPath,
  Redirect,
  Route,
  useHistory,
  useLocation
} from "react-router-dom";

const ADMIN_PATE_WHITELIST = [
  "/login",
  "/admin",
  "/admin/smart-visa",
  "/admin/setting",
];
const USER_PAGE_WHITELIST = ["/", "/login"];
const AGENT_PAGE_WHITELIST = [...USER_PAGE_WHITELIST, "/select-role"];

const PrivateRoute = ({ children, restricted = true, byPass, ...rest }) => {
  const history = useHistory();
  const currentLocation = useLocation();
  const { isLogin, userRole, currentUserRole } = useAuth();

  const currentPath = rest.path;
  const isLoginPath = !_.isEmpty(matchPath(currentPath, "/login"));

  let canAccessCurrentPath = !restricted || byPass || isLogin;
  let redirectPath = "/login";

  const checkCanAccessPage = (whitelist) =>
    whitelist.some((path) => !_.isEmpty(matchPath(currentPath, path)));

  const processRedirect = (canAccessWhitelistPath, fistTimeRedirectPath) => {
    if (canAccessWhitelistPath) {
      redirectPath = isLoginPath ? fistTimeRedirectPath : currentPath;

      if (isLoginPath && isLogin) {
        history.push(redirectPath, { from: currentLocation });
      }
    } else {
      canAccessCurrentPath = false;
    }
  };

  if (userRole === USER_ROLE.ADMIN && canAccessCurrentPath) {
    processRedirect(checkCanAccessPage(ADMIN_PATE_WHITELIST), "/admin/dashboard");
  } else if (userRole === USER_ROLE.AGENT && canAccessCurrentPath) {
    const agentAccessPath = !currentUserRole // when refresh page currentUserRole is null
      ? AGENT_PAGE_WHITELIST.filter((path) => path !== "/") // redirect to select-role when refrash page.
      : AGENT_PAGE_WHITELIST;

    processRedirect(checkCanAccessPage(agentAccessPath), "/select-role");
  } else if (userRole === USER_ROLE.USER && canAccessCurrentPath) {
    processRedirect(checkCanAccessPage(USER_PAGE_WHITELIST), "/");
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccessCurrentPath ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
